import React from 'react';
import {Create, SimpleForm} from 'react-admin';

import {CustomToolbar, Grid} from '../../components'
import AdmissionSubjectFields from './AdmissionSubjectFields'

export const AdmissionSubjectCreate = props => (
    <Create {...props}>
        <SimpleForm toolbar={<CustomToolbar/>} redirect="list">
            <Grid container spacing={8}>
                <AdmissionSubjectFields/>
            </Grid>
        </SimpleForm>
    </Create>
);

export default AdmissionSubjectCreate
